// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".transfer-form-modal .comments-container{margin-top:16px}.transfer-form-modal .comments-container .comments{width:100%;resize:none;margin:4px 0}", ""]);
// Exports
module.exports = exports;
